import { render, staticRenderFns } from "./departure-picker.vue?vue&type=template&id=5da99fd5&scoped=true&"
import script from "./departure-picker.vue?vue&type=script&lang=js&"
export * from "./departure-picker.vue?vue&type=script&lang=js&"
import style0 from "./departure-picker.vue?vue&type=style&index=0&id=5da99fd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da99fd5",
  null
  
)

export default component.exports